import {useMutation} from "@apollo/client";

import {FormModal} from "@/components/form/overlay/FormModal.tsx";
import {GQL_SCHEDULED_REPORTS, GQL_UPDATE_SCHEDULED_REPORT, SLAReport} from "@/lib/queries/reports.ts";
import {AccountUser} from "@/lib/types/accounts.ts";
import {ResponseStatus} from "@/lib/types/common.ts";
import {ScheduledReportDefaultValues, ScheduledReportForm} from "@/pages/reports/schedule/ScheduledReportForm.tsx";

interface ScheduledReportUpdateDrawerProps {
  show: boolean;
  title?: string;
  onClose: () => void;
  slaReports: SLAReport[];
  users: AccountUser[];
  defaultValues?: ScheduledReportDefaultValues;
}

export const ScheduledReportUpdateDrawer = ({
  show,
  title,
  slaReports,
  users,
  onClose,
  defaultValues,
}: ScheduledReportUpdateDrawerProps) => {
  const formId = "scheduled-report-form";
  const [updateReport, {data}] = useMutation(GQL_UPDATE_SCHEDULED_REPORT, {
    refetchQueries: [GQL_SCHEDULED_REPORTS],
    context: {
      noToast: true,
    },
  });

  return (
    <FormModal
      formId={formId}
      title={title || "New Scheduled Report"}
      show={show}
      onCancel={onClose}
      size="lg"
      centered
      hasRequiredFields
    >
      <ScheduledReportForm
        onSubmit={async (data) => {
          const r = await updateReport({
            variables: {data},
          });
          if (r.data?.response.status === ResponseStatus.SUCCESS) {
            onClose();
          }
        }}
        users={users}
        serverErrors={data?.response?.status === ResponseStatus.ERROR ? data.response.message : undefined}
        slaReports={slaReports}
        defaultValues={defaultValues}
        formId={formId}
      />
    </FormModal>
  );
};
